import PropTypes from 'prop-types';

import s from './tickerHeroBlack.module.css';

function TickerHeroBlack({ text }) {
  return (
    <div className={s.ticker}>
      <p>
        {text} <span>{`//`}</span> {text} <span>{`//`}</span>
      </p>
      <p aria-hidden="true">
        {text} <span>{`//`}</span> {text} <span>{`//`}</span>
      </p>
    </div>
  );
}

export default TickerHeroBlack;

TickerHeroBlack.propTypes = {
  text: PropTypes.string.isRequired,
};
